import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApplicationModule } from '../interfaces/application-module';
import { ApplicationModulePage } from '../interfaces/application-module-page';
import { DisplayOptionByPage } from '../interfaces/display-option-by-page';
import { FilterItem } from '../interfaces/filter-item';

@Injectable({
    providedIn: 'root',
})
export class FilterSetupService {
    private serverUrl = 'https://' + window.location.host;
    private version = '0.5'; // TODO Get version number dynamically
    private _url = (this.serverUrl + '/api/v{version}/applicationmodule').replace(
        '{version}',
        this.version
    );

    constructor(private _http: HttpClient) {}

    getApplicationModules(): Observable<ApplicationModule> {
        return this._http.get<ApplicationModule>(`${this._url}/GetAllApplicationModules/`);
    }

    getApplicationModulePagesByApplicationModuleKey(
        applicationModuleKey: number
    ): Observable<ApplicationModulePage> {
        const params = new HttpParams().set(
            'applicationModuleKey',
            applicationModuleKey.toString()
        );

        return this._http.get<ApplicationModulePage>(`${this._url}/GetApplicationModulePages/`, {
            params: params,
        });
    }

    // Is this using???
    getDisplayOptionsByApplicationModulePageKey(
        applicationModulePageKey: number
    ): Observable<DisplayOptionByPage> | any {
        const params = new HttpParams().set(
            'applicationModulePageKey',
            applicationModulePageKey.toString()
        );

        return this._http.get<DisplayOptionByPage>(
            `https://${window.location.host}/api/v0.5/displayoption/GetByApplicationModulePageKey/`,
            { params: params }
        );
    }

    getDisplayOptionFilterItemsByDisplayOptionKey(
        displayOptionKey: number
    ): Observable<FilterItem> {
        const params = new HttpParams().set('displayOptionKey', displayOptionKey.toString());

        return this._http.get<FilterItem>(
            `https://${window.location.host}/api/v0.5/filteritem/GetByDisplayOptionKey/`,
            { params: params }
        );
    }
}
